import { alphaformatDateTime } from "../../../utils/dateFormat";
import Paginator from "../../../shared/Paginator";
import config from "../../../config";
import { resolveRowLabel } from "../payload/constants";

export const getActionTypeLabel = (actionType) => {
  const actions_type_map = {1:'approve/add',2:'edit',3:'pause',4:'resume',5:'stop',6:'completed',7:'adunit position slot status'}
  return actions_type_map[actionType] || "Unknown";
};

export const getActionTypeBadgeClass = (actionType) => {
  if (actionType === 1) return "bg-green-100 text-green-700";
  if (actionType === 2) return "bg-blue-100 text-blue-700";
  if (actionType === 3) return "bg-red-100 text-red-700";
  if (actionType === 4) return "bg-orange-100 text-orange-700";
  if (actionType === 5) return "bg-purple-100 text-purple-700";
  if (actionType === 6) return "bg-gray-100 text-gray-700";
  return "bg-gray-100 text-gray-700";
};
const Table = ({ data = [], currentPage = 0, status = "pending", type = "checker", onViewPayload, onApprove, onReject, onPageChange, total = 0, viewButton = true }) => {

  const renderTableHeaders = () => {
    const baseHeaders = [
      { label: "#", key: "index" },
      { label: "User Name", key: "user_name" },
      { label: "Action Type", key: "action_type" },
      { label: "Name", key:"name" },
      { label: "Ref Table", key: "ref_table_name" },
      { label: "Date", key: "date" },
      { label: "Time", key: "time" },
    ];

    if (status === "approved") {
      baseHeaders.push({ label: "Approved Time", key: "approved_time" });
      baseHeaders.push({ label: "Approved By", key: "checker_name" });
    }

    if (status === "rejected") {
      baseHeaders.push({ label: "Rejected Time", key: "rejected_time" });
      baseHeaders.push({ label: "Rejected By", key: "checker_name" });
      baseHeaders.push({ label: "Rejected Reason", key: "rejected_reason" });
    }

    if (viewButton) {
      baseHeaders.push({ label: "Action", key: "action" });
    }

    if (status === "pending" && type === "checker" && onApprove && onReject) {
      baseHeaders.push({ label: "Manage", key: "manage" });
    }

    return baseHeaders;
  };

  return (
    <div className="p-2 md:p-6 bg-white rounded-xl shadow-sm">
      <h1 className="text-lg md:text-2xl font-bold mb-3 md:mb-6 text-gray-800 capitalize">{status} Requests</h1>

      {/* ---- Mobile-only card view (<=767px) ---- */}
      <div className="lineitems-mobile-view">
        {data.length > 0 ? (
          data.map((item, index) => {
            const { dateStr, timeStr } = alphaformatDateTime(item.time);
            const approvedTime = item.approved_time ? alphaformatDateTime(item.approved_time) : null;
            const rejectedTime = item.rejected_time ? alphaformatDateTime(item.rejected_time) : null;
            const showManage = status === "pending" && type === "checker" && onApprove && onReject;
            return (
              <div key={item.mc_id} className="border border-gray-200 rounded-xl p-3 shadow-sm bg-white">
                <div className="flex justify-between items-start gap-2">
                  <div className="min-w-0 flex-1">
                    <div className="text-xs text-gray-400 font-semibold">#{currentPage * config.PER_PAGE + index + 1} · {item.ref_table_name}</div>
                    <div className="font-semibold text-gray-800 break-words">{resolveRowLabel(item)}</div>
                    <div className="text-sm text-gray-500 break-words">{item.user_name}</div>
                  </div>
                  <span className={`px-2 py-1 rounded-full text-xs font-medium whitespace-nowrap shrink-0 ${getActionTypeBadgeClass(item.action_type)}`}>{getActionTypeLabel(item.action_type)}</span>
                </div>

                <div className="border-t border-gray-100 my-2"></div>

                <div className="flex flex-wrap gap-x-4 gap-y-1 text-sm text-gray-600">
                  <span>{dateStr} {timeStr}</span>
                  {status === "approved" && <span>Approved: {approvedTime ? approvedTime.timeStr : "N/A"}</span>}
                  {status === "rejected" && <span>Rejected: {rejectedTime ? rejectedTime.timeStr : "N/A"}</span>}
                </div>
                {(status === "approved" || status === "rejected") && (
                  <div className="text-sm text-gray-700 mt-1"><span className="text-gray-400">{status === "approved" ? "Approved by: " : "Rejected by: "}</span>{item.checker_name || "N/A"}</div>
                )}
                {status === "rejected" && (
                  <div className="text-sm text-gray-700 mt-1"><span className="text-gray-400">Reason: </span>{item.rej_reason || "N/A"}</div>
                )}

                {(viewButton || showManage) && (
                  <div className="flex gap-2 mt-3">
                    {viewButton && (
                      <button onClick={() => onViewPayload(item)} className="flex-1 px-3 py-2 bg-blue-500 hover:bg-blue-600 text-white rounded-md text-sm shadow-sm">
                        View
                      </button>
                    )}
                    {showManage && (
                      <>
                        <button onClick={() => onApprove(item)} className="flex-1 px-3 py-2 bg-green-500 hover:bg-green-600 text-white rounded-md text-sm shadow-sm">
                          Approve
                        </button>
                        <button onClick={() => onReject(item)} className="flex-1 px-3 py-2 bg-red-500 hover:bg-red-600 text-white rounded-md text-sm shadow-sm">
                          Reject
                        </button>
                      </>
                    )}
                  </div>
                )}
              </div>
            );
          })
        ) : (
          <div className="text-center text-gray-500 py-6 italic">No {status} requests found.</div>
        )}
      </div>

      <div className="overflow-x-auto mobHide">
        <table className="min-w-full border border-gray-100 rounded-lg overflow-hidden">
          <thead className="bg-gray-100">
            <tr>
              {renderTableHeaders().map((header) => (
                <th key={header.key} className="text-left p-3 font-semibold text-gray-700">
                  {header.label}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {data.length > 0 ? (
              data.map((item, index) => {
                const { dateStr, timeStr } = alphaformatDateTime(item.time);
                const approvedTime = item.approved_time ? alphaformatDateTime(item.approved_time) : null;
                const rejectedTime = item.rejected_time ? alphaformatDateTime(item.rejected_time) : null;

                return (
                  <tr key={item.mc_id} className="border-b border-gray-100 hover:bg-gray-50 transition-colors">
                    <td className="p-3 text-gray-700">{currentPage * config.PER_PAGE + index + 1}</td>
                    <td className="p-3 text-gray-700">{item.user_name}</td>
                    <td className="p-3">
                      <span className={`px-3 py-1 rounded-full text-sm font-medium ${getActionTypeBadgeClass(item.action_type)}`}>{getActionTypeLabel(item.action_type)}</span>
                    </td>
                    <td className="p-3">{resolveRowLabel(item)}</td>
                    <td className="p-3">{item.ref_table_name}</td>
                    <td className="p-3 text-gray-600">{dateStr}</td>
                    <td className="p-3 text-gray-600">{timeStr}</td>

                    {status === "approved" && (
                      <>
                        <td className="p-3 text-gray-600">{approvedTime ? approvedTime.timeStr : "N/A"}</td>
                        <td className="p-3 text-gray-700">{item.checker_name || "N/A"}</td>
                      </>
                    )}

                    {status === "rejected" && (
                      <>
                        <td className="p-3 text-gray-600">{rejectedTime ? rejectedTime.timeStr : "N/A"}</td>
                        <td className="p-3 text-gray-700">{item.checker_name || "N/A"}</td>
                        <td className="p-3 text-gray-700">
                          <pre className="bg-gray-50 p-2 rounded border border-gray-200 whitespace-pre-wrap text-sm">{item.rej_reason || "N/A"}</pre>
                        </td>
                      </>
                    )}

                    {viewButton && <td className="p-3">
                      <button onClick={() => onViewPayload(item)} className="px-4 py-2 bg-blue-500 hover:bg-blue-600 text-white rounded-md transition-colors text-sm shadow-sm">
                        View
                      </button>
                    </td>}

                    {status === "pending" && type === "checker" && onApprove && onReject && (
                      <td className="p-3 flex gap-2">
                        <button onClick={() => onApprove(item)} className="px-4 py-2 bg-green-500 hover:bg-green-600 text-white rounded-md transition-colors text-sm shadow-sm">
                          Approve
                        </button>
                        <button onClick={() => onReject(item)} className="px-4 py-2 bg-red-500 hover:bg-red-600 text-white rounded-md transition-colors text-sm shadow-sm">
                          Reject
                        </button>
                      </td>
                    )}
                  </tr>
                );
              })
            ) : (
              <tr>
                <td colSpan={renderTableHeaders().length} className="text-center text-gray-500 py-6 italic">
                  No {status} requests found.
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      <div className="flex justify-end mt-6">{Math.ceil(total / config.PER_PAGE) > 1 && onPageChange && <Paginator pageCount={Math.ceil(total / config.PER_PAGE)} handlePageClick={onPageChange} forcePage={currentPage} />}</div>
    </div>
  );
};

export default Table;
